var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-icon-button",attrs:{"title":"Move to Inbox"},on:{"click":function($event){return _vm.action()}}},[_c('md-icon',{staticClass:"text-gray"},[_vm._v("move_to_inbox")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }